// 1. React and fabric. 
export { SplendidHistory, RouteComponentProps, withRouter, Link, Route, Navigate } from '../Router5';
